import { render } from "./MyProfileView.vue?vue&type=template&id=0a73317e&scoped=true"
import script from "./MyProfileView.vue?vue&type=script&lang=js"
export * from "./MyProfileView.vue?vue&type=script&lang=js"

import "./MyProfileView.vue?vue&type=style&index=0&id=0a73317e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a73317e"]])

export default __exports__